/* CBRNMASKS — Industrial Incident Check v1.0 (2026-11-03)
 * Client-side reference-only preparedness tool. Does NOT model blast, release volume,
 * chemical dispersion, lethality, target vulnerabilities or safe stand-off distances.
 * Source services are queried in real time and are not embedded in this software.
 */
(function () {
  'use strict';
  function CBRN_TR(key) { var messages = window.CBRN_NEW_TRANSLATIONS && window.CBRN_NEW_TRANSLATIONS["industrial"]; return (messages && Object.prototype.hasOwnProperty.call(messages,key)) ? messages[key] : ''; }

  var root = document.getElementById('cbm-hi');
  if (!root) return;
  var config = Object.assign({
    defaultPlace: { lat: 48.8566, lon: 2.3522, label: CBRN_TR("j001") },
    cityGeocodeUrl: 'https://nominatim.openstreetmap.org/search',
    tileUrl: 'https://tile.openstreetmap.org/{z}/{x}/{y}.png',
    // Optional server-owned endpoint. Do not put private API tokens in public JS.
    facilityProxyUrl: '',
    maxRecords: 80,
    queryRadiusKm: 35,
    apiTimeoutMs: 9500,
    enableFranceSource: true,
    enableEeaSource: true,
    enableEpaSource: true
  }, window.CBM_INCIDENT_CONFIG || {});
  function el(id) { return document.getElementById(id); }
  function text(str) { return String(str == null ? '' : str).replace(/[&<>"']/g, function (c) {
    return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[c];
  }); }
  function num(x) { if (x === null || x === undefined || x === '') return null; var n = Number(x); return Number.isFinite(n) ? n : null; }
  function valid(lat, lon) { return Number.isFinite(lat) && Number.isFinite(lon) && Math.abs(lat) <= 90 && Math.abs(lon) <= 180; }
  function approx(x) { return Math.round(x / .05) * .05; } // deliberately several-km precision
  function distance(lat1, lon1, lat2, lon2) {
    var r = Math.PI / 180, a = Math.sin((lat2-lat1)*r/2)**2 + Math.cos(lat1*r)*Math.cos(lat2*r)*Math.sin((lon2-lon1)*r/2)**2;
    return 12742 * Math.atan2(Math.sqrt(a), Math.sqrt(1-a));
  }
  var windOpposite = { N: CBRN_TR("j002"), NE: CBRN_TR("j003"), E: CBRN_TR("j004"), SE: CBRN_TR("j005"), S: CBRN_TR("j006"), SW: CBRN_TR("j007"), W: CBRN_TR("j008"), NW: CBRN_TR("j009") };
  var state = { lat: config.defaultPlace.lat, lon: config.defaultPlace.lon, label: config.defaultPlace.label, selected: null, sites: [], incident: 'accident', release: 'unknown', wind: 'unknown', requestId: 0, map: null, meMarker: null, markers: null, hasRun: false };

  function status(str, level) { el('hi-status').textContent = str; el('hi-status').dataset.level = level || 'info'; }
  function conditions() {
    var s = state.selected;
    el('hi-conditions').innerHTML = ("<b>"+CBRN_TR("j010")+"</b>"+" ") + text(state.label) + (s ? ("<br>"+"<b>"+CBRN_TR("j011")+"</b>"+" ") + text(s.name) + ' · ' + text(s.classification) : ("<br>"+"<b>"+CBRN_TR("j012")+"</b>"+CBRN_TR("j013")));
  }
  function scenario() {
    var info = {
      accident: { heading: CBRN_TR("j014"), lead: CBRN_TR("j015") },
      drone: { heading: CBRN_TR("j016"), lead: CBRN_TR("j017") },
      missile: { heading: CBRN_TR("j018"), lead: CBRN_TR("j019") }
    }[state.incident];
    var release = state.release === 'unknown' ? CBRN_TR("j020") :
      state.release === 'release' ? CBRN_TR("j021") :
      CBRN_TR("j022");
    var wind = state.wind === 'unknown' ? CBRN_TR("j023") :
      CBRN_TR("j024") + state.wind + CBRN_TR("j025") + windOpposite[state.wind] + CBRN_TR("j026");
    el('hi-result').innerHTML = '<h4>' + text(info.heading) + '</h4><p>' + text(info.lead) + '</p><p style="margin-top:9px">' + text(release) + '</p><p style="margin-top:9px">' + text(wind) + '</p>';
  }
  function initControls() {
    root.querySelectorAll('[data-incident]').forEach(function (b) {
      b.addEventListener('click', function () {
        state.incident = b.dataset.incident;
        root.querySelectorAll('[data-incident]').forEach(function (btn) { btn.setAttribute('aria-pressed', String(btn === b)); });
        scenario();
      });
    });
    el('hi-release').addEventListener('change', function (e) { state.release = e.target.value; scenario(); });
    el('hi-wind').addEventListener('change', function (e) { state.wind = e.target.value; scenario(); });
    el('hi-search').addEventListener('submit', function (e) {
      e.preventDefault();
      var q = el('hi-location').value.trim();
      if (q.length < 2) { status(CBRN_TR("j027"), 'error'); return; }
      // Optional lat,lon input for privacy-preserving test without a geocoding service.
      var found = q.match(/^\s*(-?\d+(?:\.\d+)?)\s*,\s*(-?\d+(?:\.\d+)?)\s*$/);
      if (found) { var la = num(found[1]), lo = num(found[2]); if (valid(la, lo)) { locate(la, lo, CBRN_TR("j028")); return; } }
      geocode(q);
    });
    el('hi-geolocate').addEventListener('click', function () {
      if (!navigator.geolocation) { status(CBRN_TR("j029"), 'error'); return; }
      status(CBRN_TR("j030"));
      navigator.geolocation.getCurrentPosition(function (p) { locate(p.coords.latitude, p.coords.longitude, CBRN_TR("j031")); },
        function () { status(CBRN_TR("j032"), 'error'); },
        { enableHighAccuracy: false, timeout: 10000, maximumAge: 300000 });
    });
  }
  var geocodeBusy = false, lastGeocodeAt = 0, geocodeCache = new Map();
  async function fetchJson(url, ms, extra) {
    var ctrl = new AbortController();
    var timer = setTimeout(function () { ctrl.abort(); }, ms || config.apiTimeoutMs);
    try {
      var response = await fetch(url, Object.assign({ headers: { Accept: 'application/json' }, signal: ctrl.signal }, extra || {}));
      if (!response.ok) throw new Error(CBRN_TR("j033") + response.status);
      var json = await response.json();
      if (json && json.error) throw new Error(json.error.message || CBRN_TR("j034"));
      return json;
    } finally { clearTimeout(timer); }
  }
  async function geocode(q) {
    var key = q.toLowerCase();
    if (geocodeCache.has(key)) { var cached = geocodeCache.get(key); locate(cached.lat, cached.lon, cached.label); return; }
    if (geocodeBusy) { status(CBRN_TR("j035")); return; }
    geocodeBusy = true; el('hi-go').disabled = true;
    try {
      // The public Nominatim endpoint is for low-volume evaluation only. A production
      // e-commerce deployment needs a compliant, centrally rate-limited geocoder.
      var pause = Math.max(0, 1100 - (Date.now() - lastGeocodeAt));
      if (pause) await new Promise(function (resolve) { setTimeout(resolve, pause); });
      lastGeocodeAt = Date.now();
      status(CBRN_TR("j036") + q + '…');
      var u = config.cityGeocodeUrl + '?format=jsonv2&limit=1&accept-language=en&q=' + encodeURIComponent(q);
      var data = await fetchJson(u, 10000);
      if (!Array.isArray(data) || !data.length) { status(CBRN_TR("j037"), 'error'); return; }
      var site = {lat: num(data[0].lat), lon: num(data[0].lon), label: data[0].display_name || q};
      if (!valid(site.lat, site.lon)) throw new Error(CBRN_TR("j038"));
      geocodeCache.set(key, site); locate(site.lat, site.lon, site.label);
    } catch (err) { status(CBRN_TR("j039"), 'error'); }
    finally { geocodeBusy = false; el('hi-go').disabled = false; }
  }
  function initMap() {
    if (!window.L) { status(CBRN_TR("j040"), 'error'); return; }
    var map = L.map('hi-map', { zoomControl: true, minZoom: 2, maxZoom: 12, scrollWheelZoom: false });
    L.tileLayer(config.tileUrl, { maxZoom: 12, attribution: '&copy; <a href="https://www.openstreetmap.org/copyright">OpenStreetMap</a> contributors' }).addTo(map);
    state.map = map;
    state.markers = L.layerGroup().addTo(map);
    map.setView([state.lat, state.lon], 9);
    updateSelfMarker();
    map.on('click', function (evt) { locate(evt.latlng.lat, evt.latlng.lng, CBRN_TR("j041")); });
  }
  function updateSelfMarker() {
    if (!state.map) return;
    if (state.meMarker) state.map.removeLayer(state.meMarker);
    state.meMarker = L.circleMarker([state.lat, state.lon], { radius: 9, fillColor: '#157ba9', color: '#fff', weight: 3, opacity: 1, fillOpacity: .92, bubblingMouseEvents: false }).addTo(state.map).bindPopup(CBRN_TR("j042"));
    state.map.setView([state.lat, state.lon], 9);
  }
  function placeFromSource(source, a, lat, lon) {
    var name = String(a.siteName || a.PRIMARY_NAME || a.raisonSociale || a.raison_sociale || a.nomEtablissement || a.nom_etablissement || a.nom || '').trim();
    if (!name || !valid(lat, lon)) return null;
    var city = String(a.cities || a.CITY_NAME || a.commune || '').trim();
    var sev = a.has_seveso === 1 || a.has_seveso === '1' || /seveso/i.test(String(a.statutSeveso || a.statut_seveso || ''));
    // This is an approximate public-awareness layer: never supply exact site positions.
    return { name: name.slice(0, 160), city: city.slice(0, 120), source: source,
      lat: approx(lat), lon: approx(lon), sev: !!sev,
      classification: source === 'eea' ? (sev ? CBRN_TR("j043") : CBRN_TR("j044")) :
        source === 'fr' ? CBRN_TR("j045") : CBRN_TR("j046") };
  }
  function fromArcgis(doc, source) {
    if (!doc || !Array.isArray(doc.features)) throw new Error(CBRN_TR("j047"));
    return doc.features.map(function (f) {
      var a = f.properties || f.attributes || {}, xy = f.geometry && f.geometry.coordinates;
      var lon = num(xy && xy[0]), lat = num(xy && xy[1]);
      if (!valid(lat, lon)) { lat = num(a.y_4258 || a.LATITUDE83); lon = num(a.x_4258 || a.LONGITUDE83); }
      return placeFromSource(source, a, lat, lon);
    }).filter(Boolean);
  }
  function sourceArcgisUrl(source, lat, lon) {
    var at = Math.cos(lat * Math.PI / 180);
    var lonSpan = Math.min(2.0, config.queryRadiusKm / (111.2 * Math.max(0.25, Math.abs(at))));
    var latSpan = config.queryRadiusKm / 111.2;
    var envelope = { xmin: lon - lonSpan, ymin: lat - latSpan, xmax: lon + lonSpan, ymax: lat + latSpan, spatialReference: { wkid: 4326 } };
    var eu = source === 'eea';
    var base = eu ? 'https://air.discomap.eea.europa.eu/arcgis/rest/services/Air/IED_SiteMap/MapServer/0/query' :
      'https://services.arcgis.com/cJ9YHowT8TU7DUyn/arcgis/rest/services/FRS_INTERESTS_RMP/FeatureServer/0/query';
    var p = new URLSearchParams({ f: 'geojson', where: '1=1', geometry: JSON.stringify(envelope),
      geometryType: 'esriGeometryEnvelope', spatialRel: 'esriSpatialRelIntersects', inSR: '4326', outSR: '4326',
      outFields: eu ? 'siteName,cities,has_seveso,Site_reporting_year,x_4258,y_4258' : 'PRIMARY_NAME,CITY_NAME,STATE_CODE,LATITUDE83,LONGITUDE83',
      returnGeometry: 'true', resultRecordCount: String(config.maxRecords) });
    return base + '?' + p.toString();
  }
  async function loadEea(lat, lon) {
    // EEA industrial emissions reporting is NOT identical to Seveso classification.
    var doc = await fetchJson(sourceArcgisUrl('eea', lat, lon));
    return fromArcgis(doc, 'eea');
  }
  async function loadEpa(lat, lon) {
    var doc = await fetchJson(sourceArcgisUrl('us', lat, lon));
    return fromArcgis(doc, 'us');
  }
  function inFrance(lat, lon) { return lat > 41.0 && lat < 51.8 && lon > -5.7 && lon < 9.8; }
  function inUs(lat, lon) { return ((lat > 24 && lat < 49.5 && lon > -125 && lon < -66) || (lat > 50 && lat < 72 && lon > -170 && lon < -129) || (lat > 18 && lat < 23 && lon > -161 && lon < -154) || (lat > 17 && lat < 19 && lon > -68.5 && lon < -65)); }
  function inEurope(lat, lon) { return (lat >= 34 && lat <= 72 && lon >= -25 && lon <= 45); }
  function fromFrance(doc) {
    var arr = Array.isArray(doc) ? doc : Array.isArray(doc.data) ? doc.data : Array.isArray(doc.resultats) ? doc.resultats : Array.isArray(doc.results) ? doc.results : Array.isArray(doc.installations) ? doc.installations : null;
    if (!arr) throw new Error(CBRN_TR("j048"));
    return arr.map(function (a) {
      var flag = String(a.statutSeveso || a.statut_seveso || a.libelleStatutSeveso || '');
      if (!/seveso|seuil (haut|bas)/i.test(flag)) return null;
      var lat = num(a.latitude || a.lat), lon = num(a.longitude || a.lon);
      if ((!valid(lat, lon) || (lat === 0 && lon === 0)) && a.geolocalisation) {
        lat = num(a.geolocalisation.lat || a.geolocalisation.latitude);
        lon = num(a.geolocalisation.lon || a.geolocalisation.longitude);
      }
      if ((!valid(lat, lon) || (lat === 0 && lon === 0)) && a.geometry && Array.isArray(a.geometry.coordinates)) {
        lon = num(a.geometry.coordinates[0]); lat = num(a.geometry.coordinates[1]);
      }
      return placeFromSource('fr', a, lat, lon);
    }).filter(Boolean);
  }
  async function loadFrance(lat, lon) {
    // France's v1 service is public and needs no bearer token. v2 requires credentials.
    var u = 'https://georisques.gouv.fr/api/v1/installations_classees?latlon=' +
      encodeURIComponent(lon.toFixed(5) + ',' + lat.toFixed(5)) + '&rayon=10000&page=1&page_size=100';
    var j = await fetchJson(u, 10000);
    return fromFrance(j);
  }
  async function loadViaProxy(lat, lon) {
    var u = config.facilityProxyUrl + '?lat=' + encodeURIComponent(lat.toFixed(4)) + '&lon=' + encodeURIComponent(lon.toFixed(4));
    var j = await fetchJson(u);
    if (!j || !Array.isArray(j.sites)) throw new Error(CBRN_TR("j049"));
    return j.sites.map(function (a) { return placeFromSource(a.source, a, num(a.lat), num(a.lon)); }).filter(Boolean);
  }
  async function querySites() {
    var requestId = ++state.requestId, lat = state.lat, lon = state.lon;
    state.sites = []; state.selected = null;
    conditions(); drawSites();
    if (state.markers) state.markers.clearLayers();
    status(CBRN_TR("j050") + state.label + '…');
    var loaders = [];
    if (config.facilityProxyUrl) loaders.push({ name: CBRN_TR("j051"), run: function () { return loadViaProxy(lat, lon); } });
    else {
      if (config.enableFranceSource && inFrance(lat, lon)) loaders.push({ name: CBRN_TR("j052"), run: function () { return loadFrance(lat, lon); } });
      if (config.enableEeaSource && inEurope(lat, lon)) loaders.push({ name: CBRN_TR("j053"), run: function () { return loadEea(lat, lon); } });
      if (config.enableEpaSource && inUs(lat, lon)) loaders.push({ name: CBRN_TR("j054"), run: function () { return loadEpa(lat, lon); } });
    }
    if (!loaders.length) { status(CBRN_TR("j055")); el('hi-count').textContent = CBRN_TR("j056"); return; }
    var results = await Promise.allSettled(loaders.map(function (l) { return l.run(); }));
    if (state.requestId !== requestId) return;
    var errors = [], raw = [], success = 0;
    results.forEach(function (r, i) { if (r.status === 'fulfilled') { success++; raw.push.apply(raw, r.value); }
      else { errors.push(loaders[i].name); } });
    var unique = new Map();
    raw.forEach(function (s) {
      var key = s.name.toLowerCase().replace(/\W+/g, '') + ':' + s.lat.toFixed(2) + ':' + s.lon.toFixed(2);
      var prev = unique.get(key);
      if (!prev || (s.source === 'fr' && prev.source !== 'fr')) unique.set(key, s);
    });
    state.sites = Array.from(unique.values()).map(function (s) { s.approxDistance = distance(lat, lon, s.lat, s.lon); return s; })
      .sort(function (a,b) { return a.approxDistance - b.approxDistance; }).slice(0, 35);
    drawSites();
    if (success === 0) status(CBRN_TR("j057") + errors.join(', ') + CBRN_TR("j058"), 'error');
    else if (errors.length) status(state.sites.length + CBRN_TR("j059") + errors.join(', ') + CBRN_TR("j060"));
    else status(state.sites.length + CBRN_TR("j061") + state.label + CBRN_TR("j062"));
  }
  function selectSite(index) {
    var site = state.sites[index]; if (!site) return;
    state.selected = site; conditions(); drawSites();
    if (state.map) state.map.panTo([site.lat,site.lon]);
  }
  function drawSites() {
    var list = el('hi-sites'), count = el('hi-count');
    count.textContent = state.sites.length ? (state.sites.length + CBRN_TR('extra_records')) : CBRN_TR("j063");
    if (!state.sites.length) { list.innerHTML = ("<div class=\"hi-empty\">"+CBRN_TR("j064")+"</div>"); return; }
    list.innerHTML = state.sites.map(function (s,i) {
      var source = s.source === 'eea' ? CBRN_TR("j065") : s.source === 'fr' ? CBRN_TR("j066") : CBRN_TR("j067");
      var band = Math.max(5, Math.ceil(s.approxDistance / 5) * 5); // generalized upper-bound distance band
      return ("<button class=\"hi-site\" type=\"button\" data-index=\"") + i + '" aria-pressed="' + (state.selected === s) + '"><b>' +
        text(s.name) + '</b><small>' + text(s.city || source) + ' · ' + text(source) + CBRN_TR("j069") + band + (CBRN_TR("j070")+"</small>"+"</button>");
    }).join('');
    list.querySelectorAll('[data-index]').forEach(function (b) { b.addEventListener('click', function () { selectSite(Number(b.dataset.index)); }); });
    if (state.markers && window.L) {
      state.markers.clearLayers();
      state.sites.forEach(function (s, i) {
        var c = s.source === 'fr' ? '#ae7124' : s.source === 'us' ? '#6a57a9' : '#326e8d';
        var marker = L.circleMarker([s.lat,s.lon],{radius:7,fillColor:c,color:'#fff',weight:2,fillOpacity:.75,bubblingMouseEvents:false}).addTo(state.markers);
        marker.bindPopup('<b>' + text(s.name) + '</b><br>' + text(s.classification) + ("<br>"+CBRN_TR("j071")));
        marker.on('click', function () { selectSite(i); });
      });
    }
  }
  function locate(lat, lon, label) {
    if (!valid(lat,lon)) { status(CBRN_TR("j072"), 'error'); return; }
    state.lat = lat; state.lon = lon; state.label = label;
    updateSelfMarker(); conditions(); querySites();
  }
  initControls();
  scenario();
  conditions();
  // Defer initialization to allow the deferred Leaflet script to finish loading.
  function start() { initMap(); locate(state.lat,state.lon,state.label); }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', start, {once:true});
  else start();
})();